import React from 'react';
import { Link } from 'react-router-dom';

const points = [
  {
    title: 'Toronto-based and direct',
    copy: 'You speak with the people planning and building the work. Fewer handoffs means faster answers and clearer accountability.',
  },
  {
    title: 'Custom where it matters',
    copy: 'The customer-facing design and workflow are shaped around your business. Proven engineering foundations keep us from charging you to reinvent basics.',
  },
  {
    title: 'AI-assisted, human-reviewed',
    copy: 'We use AI inside our process to research, test, and move faster. Strategy, quality control, privacy decisions, and final responsibility remain with us.',
  },
  {
    title: 'Ownership stays clear',
    copy: 'We prefer domains, hosting, and third-party accounts in your name, with documented handoff and visible recurring costs.',
  },
];

const WhyUs = () => (
  <section className="bg-[#102A3A] px-6 py-20 text-white lg:px-8 lg:py-28">
    <div className="mx-auto max-w-7xl">
      <div className="grid gap-12 lg:grid-cols-[.72fr_1.28fr]">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#92C5D8]">Why Nexgeius</p>
          <h2 className="mt-4 max-w-lg text-4xl font-semibold leading-[1.04] tracking-[-0.045em] md:text-5xl">Small enough to care. Structured enough to deliver.</h2>
          <p className="mt-6 max-w-md text-base leading-7 text-[#C5D3DA]">Lower overhead and an efficient toolset help us price responsibly. The value still comes from understanding the business problem and standing behind the result.</p>
          <Link to="/about" className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-white">How we work <span aria-hidden="true">&rarr;</span></Link>
        </div>
        <div className="grid gap-px overflow-hidden rounded-2xl border border-white/15 bg-white/15 sm:grid-cols-2">
          {points.map((point, index) => (
            <article key={point.title} className="bg-[#102A3A] p-7 md:p-8">
              <span className="text-xs font-semibold text-[#92C5D8]">0{index + 1}</span>
              <h3 className="mt-8 text-xl font-semibold">{point.title}</h3>
              <p className="mt-3 text-sm leading-6 text-[#C5D3DA]">{point.copy}</p>
            </article>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default WhyUs;
